import { useMutation } from '@apollo/client'
import { ToggleUserNotifications, ToggleUserNotificationsVariables } from '../../types'
import { TOGGLE_USER_NOTIFICATIONS } from './operations'

export const useToggleUserNotifications = () =>
  useMutation<ToggleUserNotifications, ToggleUserNotificationsVariables>(TOGGLE_USER_NOTIFICATIONS)
